import ServiceBus from 'servicestack/service-bus'

class DashboardSourceComparisonController  {
    constructor(createAutoQuery, $session) {
        this.$session = $session;
    }

    load() {
        let $ctrl = this;
        var bus = new ServiceBus();
        var request = {
            reportName: "DashboardSalesByOrderSource",
            dateRange: "YTD",
            status: "Open,Review,Completed,On Hold"
        }
        bus.send('RunReport.json', request).then(function (response) {
            $ctrl.query = response.data; 
        });
    }
}

class DashboardSourceComparison{
    constructor(){
        this.bindings= {
            date: '@',
        };
        this.controller = DashboardSourceComparisonController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-source-comparison.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardSourceComparison', new DashboardSourceComparison());

export default DashboardSourceComparison